import React, { useState } from 'react';

const AuthForm = ({ onSubmit, buttonText }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ username, password });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col items-center space-y-4">
      <input
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        className="w-64 px-4 py-2 border border-silver rounded focus:outline-none focus:border-purple"
        placeholder="Username"
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="w-64 px-4 py-2 border border-silver rounded focus:outline-none focus:border-purple"
        placeholder="Password"
      />
      <button className="w-64 bg-purple hover:bg-bubble-gum text-white px-4 py-2 rounded-md" type="submit">
        {buttonText}
      </button>
    </form>
  );
};

export default AuthForm;
